import React from 'react';
import HomeScreen from "../homescreen/homescreen";

class MyServices extends HomeScreen {

    renderHomeContent() {
        return (
            <div>
                <div className='sectionInnerTitle'><b>Photography</b></div>
                <p className='sectionDescription'>Although I'm not a professional, I've been doing photography on the side for quite a while now. I'm mostly interested on sports and fashion, and I'm trying to cover as many events as I can (mostly badminton tournaments). If you are in need of someone with those skills, don't hesitate to <a href='/contact'><b>contact me</b></a>. Also, if you are looking to expand your portfolio as a model in a TFP (time for prints), let me know.</p>
                <p className='sectionDescription'>There are plenty of examples in <a href='/gallery'><b>gallery</b></a> of my previous shots.</p>

                <br></br>
                <div className='sectionInnerTitle'><b>Software Development</b></div>
                <p className='sectionDescription'>If you are looking for someone to build your application, whether is mobile, web or even a game, I might be the guy. With more than 10 years on the field, I've been doing pretty much everything (I shared a bit of my career in <a href='/about'>this section</a> and on my <a href='https://www.linkedin.com/in/julio-kun-3272655a'>Linkedin</a>).</p>
                <p className='sectionDescription'>Feel free to share your contact details with me <b><a href='/contact'>here</a></b> , and I'll get back to you as soon as I can. </p>
            </div>
        );
    }

    getScreenName() {
        return 'My Services';
    }
}

export default MyServices;


// WEBPACK FOOTER //
// ./src/screens/services/index.js